import formatMoney from "lib/formatMoney";
import dayjs from "dayjs";

const DSCRCalculatorQuestions = [
  {
    q_id: "0",
    q_title: "Monthly rent",
    q_description: (answers) => {
      return "What do you think you can rent the property for?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00",
    q_title: "Annual taxes",
    q_description: () => {
      return "What is actual or estimated annual tax?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000",
    q_title: "Annual insurance",
    q_description: () => {
      return "What is actual or estimated annual insurance?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000",
    q_title: "Annual HOA",
    q_description: () => {
      return "What is actual or estimated annual HOA?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000",
    q_title: "Loan purpose",
    q_description: () => {
      return "Is this a DSCR purchase or a DSCR refinance? Purpose affects the fields.";
    },
    node_type: "node",
    a_type: "mc",
    a_input_type: "",
    a_opts: (answers) => {
      return ["Purchase", "Refinance"];
    },
    q_next_step_func: (answer, answers, questions) => {
      if (answer.a_string === "Refinance") {
        return answer.q_id + "1";
      }

      return answer.q_id + "0";
    },
    q_child_nodes: [0, 1],
    q_validation_func: (answerVal) => {
      // MC so any choise is valid
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
  {
    q_id: "000000",
    q_title: "Purchase price",
    q_description: () => {
      return "What is the purchase price of the property?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [0];
    },
    q_next_step_func: (answer, answers, questions) => {
      // show final quote
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 1) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a dollar amount above 0",
    a_error: false,
  },
  {
    q_id: "000001",
    q_title: "Estimated AS-IS value",
    q_description: () => {
      return "What AS-IS value would the property appraise for?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [0];
    },
    q_next_step_func: (answer, answers, questions) => {
      return "0000010";
    },
    q_child_nodes: [0, 1],
    q_validation_func: (answerVal) => {
      if (answerVal < 1) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a dollar amount above 0",
    a_error: false,
  },
  {
    q_id: "0000010",
    q_title: "Existing debt",
    q_description: () => {
      return "Do you owe anything on this property?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [0];
    },
    q_next_step_func: (answer, answers, questions) => {
      // folds back to main path
      return "0000000";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //no valid if below 0
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a positive dollar amount",
    a_error: false,
  },
  {
    q_id: "0000000",
    q_title: "Loan to value (LTV)",
    q_description: () => {
      return "What loan to value (LTV)? Common values are between 50 and 80";
    },
    node_type: "node",
    a_type: "percent",
    a_input_type: "number",
    a_opts: (answers) => {
      return [0];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return true; //isValid
    },
    q_invalid_answer_help_text:
      "Please enter a value between 50 and 90 (a common range of offered LTVs)",
    a_error: false,
  },
  {
    q_id: "00000000",
    q_title: "Loan amount",
    q_description: () => {
      return "What is the size of the loan?";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [0];
    },
    q_next_step_func: (answer, answers, questions) => {
      // show final quote
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 1) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a dollar amount above 0",
    a_error: false,
  },

  {
    q_id: "000000000",
    q_title: "Interest rate",
    q_description: (answers, theme) => {
      return "What interest rate do you expect to pay on the loan?";
    },
    node_type: "node",
    a_type: "percent",
    a_input_type: "number",
    a_opts: (answers) => {
      return [0];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
  {
    q_id: "0000000000",
    q_title: "Origination fee",
    q_description: (answers) => {
      const loanPurpose = answers?.filter((answer) => {
        return answer?.q_title === "Loan purpose";
      })?.[0]?.a_string;
      const LTV = answers?.filter((answer) => {
        return answer?.q_title === "Loan to value (LTV)";
      })?.[0]?.a_string;
      let propertyValue;
      if (loanPurpose === "Purchase") {
        const purchasePrice = answers.filter((answer) => {
          return answer.q_title === "Purchase price";
        })[0]?.a_string;
        propertyValue = purchasePrice;
      }
      if (loanPurpose === "Refinance") {
        const estimatedAsIsValue = answers.filter((answer) => {
          return answer.q_title === "Estimated AS-IS value";
        })[0]?.a_string;
        propertyValue = estimatedAsIsValue;
      }
      const loanAmount = propertyValue * (LTV / 100);

      const originationFee =
        parseInt(loanAmount) < 200000 ? 2000 : parseInt(loanAmount) * 0.01;

      return `This is the only fee that goes directly to OfferMarket and covers our operating costs to process and underwrite the Loan File. Our fee for this loan will be $${formatMoney(
        parseInt(originationFee),
        0
      )}`;
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000000000",
    q_title: "Loan fees",
    q_description: (answers) => {
      const loanFees = 1995;
      return `This a fixed fee of $${formatMoney(
        parseInt(loanFees),
        0
      )} that includes several third party fees (it doesn't go to OfferMarket). It is necessary to verify documents for underwriting and reduce single party risk of the inputs that make up the Loan File. Specifically, it includes underwriting fee which is used to cover the costs of reserching and verifying the information in the loan file. Appraisal risk review, which employes a third party to certify the accuracy of the appraisal report. CoreLogic report, a third party report which is used to access the risks and trends that apply to the underlying collateral (the property) used to secure this loan.`;
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000000000000",
    q_title: "Title fees",
    q_description: (answers) => {
      const loanPurpose = answers?.filter((answer) => {
        return answer?.q_title === "Loan purpose";
      })?.[0]?.a_string;

      const LTV = answers?.filter((answer) => {
        return answer?.q_title === "Loan to value (LTV)";
      })?.[0]?.a_string;

      let propertyValue;
      if (loanPurpose === "Purchase") {
        const purchasePrice = answers.filter((answer) => {
          return answer.q_title === "Purchase price";
        })[0]?.a_string;
        propertyValue = purchasePrice;
      }

      if (loanPurpose === "Refinance") {
        const estimatedAsIsValue = answers.filter((answer) => {
          return answer.q_title === "Estimated AS-IS value";
        })[0]?.a_string;
        propertyValue = estimatedAsIsValue;
      }

      const loanAmount = propertyValue * (LTV / 100);

      return `Estimate of Title fees is usually around 1% of loan amount which comes out to ${formatMoney(
        parseInt(loanAmount) * 0.01,
        0
      )}`;
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000000000000",
    q_title: "Escrow",
    q_description: (answers) => {
      const annualTaxes = answers?.filter((answer) => {
        return answer?.q_title === "Annual taxes";
      })?.[0]?.a_string;

      const annualInsurance = answers?.filter((answer) => {
        return answer?.q_title === "Annual insurance";
      })?.[0]?.a_string;

      // let propertyValue;
      // if (loanPurpose === "Purchase") {
      //   const purchasePrice = answers.filter((answer) => {
      //     return answer.q_title === "Purchase price";
      //   })[0]?.a_string;
      //   propertyValue = purchasePrice;
      // }

      // if (loanPurpose === "Refinance") {
      //   const estimatedAsIsValue = answers.filter((answer) => {
      //     return answer.q_title === "Estimated AS-IS value";
      //   })[0]?.a_string;
      //   propertyValue = estimatedAsIsValue;
      // }

      // const loanAmount = propertyValue * (LTV / 100);

      return `At closing an escrow is collected which will be used to pay for the first 3 months of taxes and insurance. The amount is equal to 3 months of taxes and insurance payments, which is $${formatMoney(
        (parseInt(annualTaxes) * 3) / 12 + (parseInt(annualInsurance) * 3) / 12,
        0
      )}`;
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000000000000",
    q_title: "Prepaid interest",
    q_description: (answers) => {
      const loanPurpose = answers?.filter((answer) => {
        return answer?.q_title === "Loan purpose";
      })?.[0]?.a_string;

      const LTV = answers?.filter((answer) => {
        return answer?.q_title === "Loan to value (LTV)";
      })?.[0]?.a_string;

      let propertyValue;
      if (loanPurpose === "Purchase") {
        const purchasePrice = answers.filter((answer) => {
          return answer.q_title === "Purchase price";
        })[0]?.a_string;
        propertyValue = purchasePrice;
      }

      if (loanPurpose === "Refinance") {
        const estimatedAsIsValue = answers.filter((answer) => {
          return answer.q_title === "Estimated AS-IS value";
        })[0]?.a_string;
        propertyValue = estimatedAsIsValue;
      }

      const loanAmount = propertyValue * (LTV / 100);

      const [interestRate] = answers.filter((answer) => {
        return answer?.q_title === "Interest rate";
      });

      const today = dayjs();

      // Get the end of the current month
      const endOfMonth = today.endOf("month");

      // Calculate the difference in days between today and the end of the month
      const daysUntilEndOfMonth = endOfMonth.diff(today, "day");

      const prepaidInterest =
        ((loanAmount * (parseFloat(interestRate.a_string) / 100)) / 365) *
        daysUntilEndOfMonth;

      return `At closing, lenders collect prepayment of interest through the end of the month. If loan is closed today this amount would be $${formatMoney(
        parseInt(prepaidInterest),
        0
      )}`;
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000000000000000",
    q_title: "Prepaid insurance",
    q_description: (answers) => {
      const annualInsurance = answers?.filter((answer) => {
        return answer?.q_title === "Annual insurance";
      })?.[0]?.a_string;

      // const loanPurpose = answers?.filter((answer) => {
      //   return answer?.q_title === "prepaidInsurance";
      // })?.[0]?.a_string;

      // const LTV = answers?.filter((answer) => {
      //   return answer?.q_title === "Loan to value (LTV)";
      // })?.[0]?.a_string;

      // let propertyValue;
      // if (loanPurpose === "Purchase") {
      //   const purchasePrice = answers.filter((answer) => {
      //     return answer.q_title === "Purchase price";
      //   })[0]?.a_string;
      //   propertyValue = purchasePrice;
      // }

      // if (loanPurpose === "Refinance") {
      //   const estimatedAsIsValue = answers.filter((answer) => {
      //     return answer.q_title === "Estimated AS-IS value";
      //   })[0]?.a_string;
      //   propertyValue = estimatedAsIsValue;
      // }

      // const insuranceEstimator = 0.01125;
      // const prepaidInsurance = parseInt(propertyValue) * insuranceEstimator;

      return `At closing, lenders often require that the 1st year of insurance is covered. A rough estimate of annual insurance is $${formatMoney(
        parseInt(annualInsurance),
        0
      )}`;
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000000000000000",
    q_title: "Credit score",
    q_description: (answers) => {
      return "What is your estimated tri-merge credit score?";
    },
    node_type: "node",
    a_type: "number",
    a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      // return answer.q_id + "0";
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0 || answerVal > 800) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Credit score must be between 800 and 0",
    a_error: false,
  },
  // for simplicity, hardcoding refinance type for dscr calc to always be cashout
  // this wont' be asked, but necessary for correct output
  {
    q_id: "00000000000000000",
    q_title: "Refinance type",
    q_description: () => {
      return "What type of refinance do you want to complete?";
    },
    node_type: "leaf",
    a_type: "mc",
    a_input_type: "",
    a_opts: (answers) => {
      return ["Cash out refinance", "Rate term refinance"];
    },
    q_next_step_func: (answer, answers, questions) => {
      if (answer.a_string === "Yes") {
        return answer.q_id + "1";
      }
      return answer.q_id + "0";
    },
    q_child_nodes: [0, 1],
    q_validation_func: (answerVal) => {
      // mc all are valid
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
    a_string: "Cash out refinance",
  },
  {
    q_id: "000000000000000000",
    q_title: "Calculation name",
    q_description: () => {
      return "What would you like to name this calculation. Ex. 'First option for 777 Happy Choice Rd.' ";
    },
    node_type: "node",
    a_type: "text",
    a_input_type: "text",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
  {
    q_id: "0000000000000000000",
    q_title: "Address (optional)",
    q_description: () => {
      return "Enter property address to help organize your calculations. You can also enter a state, zip or nothing, since this field is optional.";
    },
    node_type: "node",
    a_type: "address",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_validation_func: (answerVal) => {
      //   make sure not false and a string of none 0 length
      if (!answerVal && !answerVal.length > 0) {
        return false;
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter or select an address",
    a_error: false,
  },
];

export default DSCRCalculatorQuestions;
